export const attackerKeys = {
  all: ["attacker"] as const,
  attacker: (attackerId: string) => [...attackerKeys.all, "attacker", attackerId] as const,
  project: (projectId: string) => [...attackerKeys.all, "project", projectId] as const,
};
